'use strict';
import ErrorType from '../constants/error-type';
var Device = require('../util/device');
var Debug = require('../util/debug')('windows-phone-fallback');
var VideoAttributes = require('../util/video-attributes');
var VideoDataBuilder = require('../util/video-data-builder');

var NAMESPACE = 'wpfallback';

module.exports = {
	create: function (api) {
		function _sendEvent(eventType, data) {
			Debug('Send event: ' + eventType, data);
			api.fire(eventType, data);
		}

		function _buildExternalDeviceUrl(jsonurl, protocol) {
			var currProtocol = protocol || window.location.protocol || 'http:';
			var basepath = currProtocol + '//www.svtplay.se';
			var url = (/^\//.test(jsonurl) ? (basepath + jsonurl) : jsonurl);

			return url.replace('http:', currProtocol);
		}

		var deviceFallbackController = {
			_metadata: null,
			_active: false,

			/* Public Methods */
			handleError: function (e) {
				this._active = !!this._metadata;

				if (this._active) {
					// Hack to ensure that defaultPrevented gets set.
					Object.defineProperty(e, 'defaultPrevented', {
						get: function () {
							return true;
						}
					});

					return false;
				}

				return true;
			},

			play: function () {
				if (this._active) {
					var videoData = VideoDataBuilder.build(api.data().videoId, this._metadata, api);

					videoData.video.position = VideoAttributes.getStartPosition(api.video());
					videoData.video.subtitleReferences = videoData.video.subtitleReferences || [{url: ''}];

					var jsonurl = 'http://api.svt.se/videoplayer-embed/android/videodata/?json=' + encodeURIComponent(JSON.stringify(videoData)),
						url;
					//WP app detection.
					if (Device.isWindowsPhone()) {
						this._notifyExternalPlaying(jsonurl);
						url = _buildExternalDeviceUrl(jsonurl, 'svtplay:');
						Debug('changeVideo windows_phone-url: ' + url);
						window.location = url;

						return true;
					}
					//W8 app detection.
					else if (Device.isWindows8App()) {
						this._notifyExternalPlaying(jsonurl);
						url = _buildExternalDeviceUrl(jsonurl);
						url = '//www.svtplay.se/app/windows8?play=' + encodeURIComponent(url);
						Debug('changeVideo windows_8-url: ' + url);
						window.location = url;

						return true;
					}
					//Default
					else {
						Debug.error('Could not find suitable fallback version');
					}
				}

				return false;
			},

			load: function () {
				var _this = this;
				api.on(NAMESPACE + '.' + ErrorType.UNKNOW_VIDEO_TYPE_ERROR, this.handleError.bind(this));
				api.on(NAMESPACE + '.metadata', function (data) {
					_this._metadata = data ? data.detail : null;
				});
			},

			unload: function () {
				api.off(NAMESPACE + '.' + ErrorType.UNKNOW_VIDEO_TYPE_ERROR);
				api.off(NAMESPACE + '.metadata');
			},

			/**
			 * Fire and forget!
			 * Notify listeners that an external player
			 * will be playing, do whatever necessary before changing app.
			 * @param jsonurl
			 * @private
			 */
			_notifyExternalPlaying: function (jsonurl) {
				// Fire and forget event for a external video start
				_sendEvent('playing', jsonurl);
				api.reset();
				_sendEvent('ready', {
					videoId: api.data().videoId,
					externalUi: true
				});
			}

		};

		if (Device.isWindowsPhone() || Device.isWindows8App()) {
			// Unload old deviceFallbackController if any
			if (api.deviceFallbackController) {
				api.deviceFallbackController.unload();
			}

			var filter = {
				load: function () {
					this._metadata = false;
				},
				play: function () {
					return !!deviceFallbackController.play();
				}
			};

			deviceFallbackController.load();
			api.filters.push(filter);

			api.deviceFallbackController = deviceFallbackController;
		}
	},

	destroy: function (api) {
		var deviceFallbackController = api.deviceFallbackController;
		if (deviceFallbackController) {
			deviceFallbackController.unload();
		}
		api.deviceFallbackController = undefined;
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/windows-phone-fallback.js